export default __webpack_public_path__ + "static/media/pencil-grey-16px.5ad57734.svg";